import { useHover } from '@mantine/hooks';
import { Group, Stack, Text } from '@mantine/core';
import DatasetIcon from '@/components/DatasetIcon.tsx';
import React from 'react';
import { Dataset } from '@/types/datasets.ts';

type props = {
  dataset: Dataset;
  addTab: (datasetId: string) => void;
};

const DatasetItemUI = ({ dataset, addTab }: props) => {
  const { hovered, ref: hoverRef } = useHover();

  return (
    <Group
      px={'xs'}
      h={'30px'}
      align={'center'}
      style={{
        borderRadius: '5px',
        background: hovered ? '#F2F6F7' : 'transparent',
        cursor: 'pointer',
      }}
      ref={hoverRef}
      wrap={'nowrap'}
      gap={'xs'}
      onClick={() => addTab(dataset.id)}
    >
      <DatasetIcon dataset={dataset} size={'18px'} />
      <Stack style={{ flex: 1, minWidth: 0 }}>
        <Text c={'#0F172A'} truncate={'end'} size={'12px'}>
          {dataset.name}
        </Text>
      </Stack>
    </Group>
  );
};

export default DatasetItemUI;
